<template>
  <div>
    <!-- Top navbar -->
    <nav class="navbar navbar-top navbar-expand-md bg-white shadow border-bottom" id="navbar-main">
      <div class="container-fluid">
        <!-- Brand -->
        <router-link :to="{ name: 'completedSession' }" class="h4 mb-0 text-uppercase d-none d-lg-inline-block">
          Closed Session
        </router-link>
        <user-data></user-data>

      </div>
    </nav>
    <!-- List view content -->
    <div class="container-fluid mt-0 pt-5 pt-md-8" v-if="listFlag">
      <div class="row mb-5 mb-xl-0">
        <div class="col-md-3">
          <b-form-group label="Site" label-for="session">
            <b-form-select id="session" @input="getCompletedList(form), getMeterList()" v-model="form.site_id"
              class="form-control-alternative">
              <option value="null" class="bg-grey text-white" disabled selected>Please select Site</option>
              <option v-for="list in coPropList.data" :key="list.id" v-bind:value='list.id'>{{ list.name }}</option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group label="Meter Type" label-for="session">
            <b-form-select id="session" @input="getCompletedList(form)" v-model="form.service_type_id"
              class="form-control-alternative" :disabled="form.site_id == null">
              <option value='null' class="bg-grey text-white" disabled selected>Please select Meter</option>
              <option v-for="list in meterList" :key="list.id" v-bind:value='list.id'>{{ list.service_name }}</option>
            </b-form-select>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group id="formDate" label="From Date" label-for="formDate">
            <date-picker v-model="form.dateFrom" :config="dateFormat" placeholder="Please select from date"
              class="form-control-alternative" @input="modifyPage(form)" :disabled="form.site_id == null"></date-picker>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <b-form-group id="toDate" label="To Date" label-for="toDate">
            <date-picker v-model="form.dateTo" :config="dateFormat" placeholder="Please select to date"
              class="form-control-alternative" @input="modifyPage(form)"
              :disabled="form.site_id == null || form.dateFrom == ''"></date-picker>
          </b-form-group>
        </div>
        <!-- <div class="col-md-3" v-if="completedSessionList.length !== 0 && completedSessionList[0].user !== null">
          <p>Surveyor</p>
          <h4>{{completedSessionList[0].user.name}}</h4>
        </div>
        <div class="col-md-3" v-if="completedSessionList.length !== 0 && completedSessionList[0].user !== null">
          <p>Started On</p>
          <p><strong>{{completedSessionList[0].survey_start_date | moment('YYYY-MM-DD h:mm a')}} </strong></p>
        </div> -->
      </div>
      <div class="row mt-4" v-if="form.site_id != null">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Closed Session Data</h3>
                </div>
              </div>
            </div>
            <div class="table-responsive" v-if="completedSessionData.total_count != 0">
              <b-table class="mt-3" striped hover :items="completedSessionList" :fields="listFields">
                <template slot="index" slot-scope="data">
                  {{ data.index + 1 }}
                </template>
                <template slot="coProp" slot-scope="data">
                  {{ data.item.site.name }}
                </template>
                <template slot="meterType" slot-scope="data">
                  {{ data.item.service_type.service_name }}
                </template>
                <template slot="created_at" slot-scope="data">
                  <!-- {{data.item.survey_start_date |moment('YYYY-MM-DD h:mm a')}} -->
                  {{ data.item.survey_end_date | moment('DD MMM YYYY h:mm a') }}
                </template>
                <template slot="total_lot_count" slot-scope="data">
                  {{ data.value }}
                </template>
                <template slot="total_load_units" slot-scope="data">
                  {{ data.item.total_load_units | formatNumber }}
                </template>
                <template slot="total_load_charge" slot-scope="data">
                  {{ data.item.total_load_charge | currency }}
                </template>
                <template slot="actions" slot-scope="data">
                  <div class="d-flex w-100 justify-content-between font-size">
                    <b-link v-b-tooltip.hover="'View all readings'" @click='detailView(data.item, "view")'
                      class="text-info"><i class="far fa-eye mr-2"></i></b-link>
                    <!-- Single Download Button -->
                    <b-link v-b-tooltip.hover="'Download readings'" @click="showDownloadModal(data.item.id)"
                      class="text-success">
                      <i class="fas fa-download mr-2"></i>
                    </b-link>

                    <!-- Single Email Button -->
                    <b-link v-if="data.item.is_mail_scheduled == 1" v-b-tooltip.hover="'Email'"
                      @click="showEmailModal(data.item.id)" class="text-primary">
                      <i class="fas fa-envelope mr-2"></i>
                    </b-link>


                    <!-- Single Email Button -->
                    <b-link v-else v-b-tooltip.hover="'Email'" @click="showEmailModal(data.item.id)"
                      class="text-danger">
                      <i class="fas fa-envelope mr-2"></i>
                    </b-link>


                    <!-- Popup for download options -->
                    <b-modal :ref="'download-modal-' + data.item.id" ok-only ok-title="Close"
                      title="Choose Download Option">
                      <div class="alert alert-primary" role="alert">
                        Microsoft Excel format. <a
                          :href="apiUrl + 'site-service-csv?' + 'site_id=' + data.item.site.id + '&service_type_id=' + data.item.service_type.id + '&created_at=' + data.item.created_at + '&sp=' + data.item.service_provider_id + '&uuid=' + data.item.uuid"
                          class="alert-link">Download</a>.
                      </div>
                      <div class="alert alert-info" role="alert">
                        Bills in pdf format <a
                          :href="apiUrl + 'site-service-pdf?' + 'site_id=' + data.item.site.id + '&service_type_id=' + data.item.service_type.id + '&created_at=' + data.item.created_at + '&sp=' + data.item.service_provider_id + '&uuid=' + data.item.uuid"
                          class="alert-link">Download</a>.
                      </div>
                      <div class="alert alert-success" role="alert">
                        Notice of use in pdf format <a
                          :href="apiUrl + 'site-service-pdf?' + 'site_id=' + data.item.site.id + '&service_type_id=' + data.item.service_type.id + '&created_at=' + data.item.created_at + '&sp=' + data.item.service_provider_id + '&uuid=' + data.item.uuid + '&view=notify'"
                          class="alert-link">Download</a>.
                      </div>
                      <div class="alert alert-warning" role="alert">
                        Text file format <a
                          :href="apiUrl + 'site-service-txt?' + 'site_id=' + data.item.site.id + '&sp=' + data.item.service_provider_id + '&uuid=' + data.item.uuid"
                          class="alert-link">Download</a>.
                      </div>
                    </b-modal>

                    <!-- Popup for email -->
                    <b-modal ok-only ok-title="Close" :ref="'email-modal-' + data.item.id" title="Schedule email">

                      <div class="alert alert-primary" role="alert" v-if="data.item.is_mail_scheduled == 1">
                        <i class="far fa-check mr-2"></i> Email has been scheduled for this session.
                      </div>

                      <!-- <div v-else>
                        <h3>Email type</h3>
                        <b-form-group>
                          <b-form-radio-group v-model="type" name="some-radios" inline>
                            <b-form-radio value="mail">Bill</b-form-radio>
                            <b-form-radio value="another">Notice of consumption</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>

                        <div class="mt-3">Selected: <strong>{{ type }}</strong></div>
                      </div> -->

                      <div v-else>
                        <h3>Choose an email type</h3>
                        <div class="d-flex justify-content-around mt-3">
                          <b-button variant="primary" @click='detailView(data.item, "mail")'>Bill</b-button>
                          <b-button variant="secondary" @click='detailView(data.item, "another")'>Notice of
                            Consumption</b-button>
                        </div>
                      </div>




                    </b-modal>

                  </div>
                </template>
              </b-table>
              <div class="card-footer border-0">
                <b-pagination align="right" @input="pageClick(currentPage)"
                  :total-rows="completedSessionData.total_count" v-model="currentPage" :per-page="10">
                </b-pagination>
              </div>
            </div>
            <div v-if="completedSessionData.total_count == 0">
              <h5 class="text-center py-5">No records available</h5>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-4" v-if="form.site_id == null">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow mb-5">
            <div class="row m-0 px-2 pb-4">
              <div class="col-md-12">
                <h4 class="py-5 my-3 text-center"> Please select co props</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Detail view content -->
    <div class="container-fluid mt-0 pt-5 pt-md-8" v-if="viewFlag">

      <div class="session-summary-bar shadow-sm summary-box mb-3">
        <div class="stat-chip">
          <span class="stat-label">Site</span>
          <span class="stat-value">
            {{ siteDetails.site.name }}
            <b-link v-if="completedSessionLots.data && completedSessionLots.data.data && completedSessionLots.data.data.length"
              v-b-tooltip.hover="'Copy UUID'"
              @click="copyUuid(completedSessionLots.data.data[0].uuid)"
              class="text-info ml-1"><i class="fas fa-copy"></i></b-link>
          </span>
        </div>
        <div class="stat-chip">
          <span class="stat-label">Meter Type</span>
          <span class="stat-value">{{ siteDetails.service_type.service_name }}</span>
        </div>
        <div class="stat-chip">
          <span class="stat-label">Total Units Billed</span>
          <span class="stat-value">{{ sessionSummary.total_units || 0 | formatNumber }}</span>
        </div>
        <div class="stat-chip">
          <span class="stat-label">Total Billed Value</span>
          <span class="stat-value">{{ sessionSummary.total_billed || 0 | currency }}</span>
        </div>
        <div class="stat-chip" v-if="isWaterDetailSession">
          <span class="stat-label">Bowser Amount</span>
          <span class="stat-value">{{ sessionSummary.total_tanker_allocated || sessionSummary.total_bowser_allocated || 0 | currency }}</span>
        </div>
        <div class="stat-chip" v-if="isWaterDetailSession">
          <span class="stat-label">Allocation Basis <i class="fas fa-info-circle text-muted" v-b-tooltip.hover :title="allocationBasisMessage" style="cursor:help;"></i></span>
          <span class="stat-value">{{ allocationBasisLabel }}</span>
        </div>
        <div class="stat-chip" v-if="isWaterDetailSession">
          <span class="stat-label">Common Consumption</span>
          <span class="stat-value">{{ formatPercent(sessionSummary.estimated_common_ratio_used) }}</span>
        </div>
        <div class="stat-chip" v-if="isWaterDetailSession && mainMeterRow">
          <span class="stat-label">Main Meter</span>
          <span class="stat-value">{{ mainMeterRow.lot && mainMeterRow.lot.lot_no ? mainMeterRow.lot.lot_no : 'Main meter' }}</span>
        </div>
        <div class="stat-chip" v-if="isWaterDetailSession && mainMeterRow">
          <span class="stat-label">Main Supply</span>
          <span class="stat-value">{{ rowConsumption(mainMeterRow) | formatNumber }}</span>
        </div>
        <div class="stat-chip" v-if="isWaterDetailSession && mainMeterRow">
          <span class="stat-label">Avg Common Ratio</span>
          <span class="stat-value">{{ formatPercent(sessionSummary.average_common_ratio_for_site) }}</span>
        </div>
        <div class="stat-chip">
          <span class="stat-label">Closed By</span>
          <span class="stat-value">{{ detailHeaderRow && detailHeaderRow.surveyor_closed ? detailHeaderRow.surveyor_closed.email : '-' }}</span>
        </div>
        <div class="stat-chip">
          <span class="stat-label">Closed Date</span>
          <span class="stat-value">{{ detailHeaderRow && detailHeaderRow.survey_end_date ? $options.filters.moment(detailHeaderRow.survey_end_date, 'DD MMM YYYY h:mm a') : '-' }}</span>
        </div>
        <div class="stat-chip stat-chip--action" v-if="isWaterDetailSession">
          <b-button variant="outline-info" size="sm" @click="showCommonConsumptionModal">
            <i class="fas fa-chart-line mr-1"></i> Supply History
          </b-button>
        </div>
      </div>



      <div class="row mt-4">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col d-flex align-items-center">
                  <button type="button" class="btn btn-primary mr-3" @click="listView">
                    <i class="fas fa-arrow-left mr-2"></i>
                    Back
                  </button>
                  <h3 class="mb-0">Lots Details</h3>
                </div>
              </div>
            </div>

            <div class="table-responsive" v-if="pagination.total != 0">
              <b-table class="mt-3" striped hover :items="detailRows" :fields="lotFields">
                <!-- <template slot="index" slot-scope="data">
                  {{ data.index }}
                </template> -->
                <template slot="ref" slot-scope="data">
                  {{ data.id }}
                </template>
                <template slot="lotNo" slot-scope="data">
                  {{ data.lot.lot_no }}
                </template>
                <template slot="owner" slot-scope="data">
                  {{ data.lot.lot_owner.name }}
                </template>
                <template slot="units_consumed" slot-scope="data">
                  {{ rowConsumption(data.item) | formatNumber }}
                </template>
                <template slot="net_bill_value" slot-scope="data">
                  {{ data.item.net_bill_value | currency }}
                </template>
                <template slot="survey_start_date" slot-scope="data">
                  {{ data.item.survey_start_date | moment('DD MMM YYYY h:mm a') }}
                </template>
                <template slot="survey_start_by" slot-scope="data">
                  {{ data.item.user.email }}
                </template>
                <template slot="survey_end_date" slot-scope="data">
                  {{ data.item.survey_end_date | moment('DD MMM YYYY h:mm a') }}
                </template>
                <template slot="surveyor_end_by" slot-scope="data">
                  {{ data.item.surveyor_closed.email }}
                </template>
                <!-- <template slot="survey_end_date" slot-scope="data">
                  {{data.item.survey_end_date}}
                </template> -->
                <!-- <template slot="survey_end_by" slot-scope="data">
                  {{data.item.survey_closed.name}}
                </template> -->
                <template slot="actions" slot-scope="data">
                  <b-link v-b-tooltip.hover="'View photo'" @click='detailView(data, "lotImage")' class="text-success"><i
                      class="far fa-image mr-2"></i></b-link>
                  <b-link v-b-tooltip.hover="'View bill'"
                    :href="apiUrl + 'lot-pdf?' + 'archived_session_id=' + data.item.id + '&sp=' + data.item.service_provider_id"
                    class="text-danger"><i class="far fa-file-pdf mr-2"></i></b-link>
                  <b-link v-b-tooltip.hover="'View notification of usage'"
                    :href="apiUrl + 'lot-pdf?' + 'archived_session_id=' + data.item.id + '&sp=' + data.item.service_provider_id + '&view=notify'"
                    class="text-info"><i class="fas fa-exclamation-circle mr-2"></i></b-link>
                </template>
              </b-table>
              <div class="card-footer border-0">
                <b-pagination align="right" @input="detailPageClick(currentPage)" :total-rows="pagination.total"
                  v-model="currentPage" :per-page="pagination.per_page">
                </b-pagination>
              </div>
            </div>
            <div class="table-responsive" v-if="pagination.total == 0">
              <h5 class="py-5 text-center">No records available</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="imgModal" size="xl" hide-footer :title="'Lot No: ' + currentLotNo" :dialog-class="'fullscreen-modal'"
      centered no-close-on-backdrop no-close-on-esc @hidden="hideLoupe">
      <div class="image-viewer-container">
        <div v-if="loadingImage" class="spinner-border text-primary loader-center" role="status">
          <span class="sr-only">Loading Image...</span>
        </div>
        <template v-else>
          <b-button variant="light" class="download-btn" @click="downloadImage" v-b-tooltip.hover
            title="Download Image">
            <i class="fas fa-download"></i>
          </b-button>
          <div class="loupe-wrapper fullscreen-image-wrapper" @mouseenter="showLoupe" @mouseleave="hideLoupe"
            @mousemove="updateLoupe">
            <img ref="meterImage" :src="imgUrl" alt="Meter Image" class="fullscreen-image" @load="handleMeterImageLoad" />
            <div v-if="loupeVisible" class="loupe-lens" :style="loupeLensStyle"></div>
          </div>
        </template>
      </div>
    </b-modal>

    <b-modal ref="commonConsumptionModal" title="Supply History" ok-only ok-title="Close" dialog-class="fullscreen-modal supply-history-modal" size="xl">
      <div v-if="commonConsumptionHistory.data && commonConsumptionHistory.data.length">
        <div class="table-responsive">
          <b-table striped hover :items="commonConsumptionHistory.data" :fields="commonConsumptionFields">
            <template slot="cycle_date" slot-scope="data">
              {{ data.item.cycle_date | moment('DD MMM YYYY') }}
            </template>
            <template slot="main_consumption" slot-scope="data">
              {{ data.item.main_consumption | formatNumber }}
            </template>
            <template slot="private_consumption" slot-scope="data">
              {{ data.item.private_consumption | formatNumber }}
            </template>
            <template slot="common_ratio" slot-scope="data">
              {{ formatPercent(data.item.common_ratio) }}
            </template>
            <template slot="tanker_volume" slot-scope="data">
              {{ data.item.tanker_volume != null ? (data.item.tanker_volume | formatNumber) : '-' }}
            </template>
            <template slot="total_supply" slot-scope="data">
              {{ (Number(data.item.main_consumption || 0) + Number(data.item.tanker_volume || 0)) | formatNumber }}
            </template>
            <template slot="tanker_cost" slot-scope="data">
              {{ data.item.tanker_cost != null ? (data.item.tanker_cost | currency) : '-' }}
            </template>
          </b-table>
        </div>
        <b-pagination
          v-if="commonConsumptionHistory.last_page > 1"
          v-model="ccPage"
          :total-rows="commonConsumptionHistory.total"
          :per-page="commonConsumptionHistory.per_page"
          align="right"
          class="mt-2 mb-0 px-3"
          @input="ccPageChanged"
        ></b-pagination>
      </div>
      <p v-else class="mb-0 text-center py-4">No supply history available.</p>
    </b-modal>

    <!-- Pre-mailing check modal -->
    <b-modal ref="mailCheckModal" title="Email Check" hide-footer no-close-on-backdrop no-close-on-esc centered>
      <!-- Checking state -->
      <div v-if="mailCheckLoading" class="text-center py-4">
        <b-spinner variant="primary" class="mb-3"></b-spinner>
        <p class="mb-0 text-muted">Checking for invalid email addresses...</p>
      </div>

      <!-- All clear -->
      <div v-else-if="mailCheckFailures.length === 0" class="text-center py-4">
        <i class="fas fa-check-circle text-success mb-3" style="font-size:40px;"></i>
        <p class="mb-0 text-success font-weight-bold">No invalid addresses found</p>
        <p class="text-muted small mt-1">Scheduling mailing...</p>
      </div>

      <!-- Failures found -->
      <div v-else>
        <div class="alert alert-warning mb-3">
          <i class="fas fa-exclamation-triangle mr-2"></i>
          <strong>{{ mailCheckFailures.length }} failed address{{ mailCheckFailures.length > 1 ? 'es' : '' }} from the last mailing</strong>
        </div>
        <ul class="list-unstyled mb-4">
          <li v-for="item in mailCheckFailures" :key="item.lot_no" class="mb-2 p-2 border rounded">
            <span class="font-weight-bold text-danger mr-2">{{ item.lot_no }}</span>
            <span class="text-muted small">{{ item.reason }}</span>
          </li>
        </ul>
        <div class="d-flex justify-content-end">
          <b-button variant="secondary" class="mr-2" @click="$refs.mailCheckModal.hide()">
            Cancel &amp; Correct
          </b-button>
          <b-button variant="warning" @click="proceedWithMailing()">
            Ignore &amp; Continue
          </b-button>
        </div>
      </div>
    </b-modal>

  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import userData from '@/pages/Common/userData';
import { storagePath, apiUrl } from '@/config'
import noImageUrl from '@/assets/img/theme/noImage.png'
export default {
  components: {
    userData,
    datePicker,
    type: 'mail', // or default value
  },
  data() {
    return {
      detailData: null,
      currentLotNo: '', // store for caption
      loadingImage: false, // ← used to toggle loader/spinner
      listFlag: true,
      viewFlag: false,
      apiUrl,
      pagination: {},
      total: {},
      currentPage: 1,
      totalPageCount: 1,
      ccPage: 1,
      mailCheckLoading: false,
      mailCheckFailures: [],
      pendingMailPayload: null,
      pendingMailFlag: null,
      dateFormat: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
        showClear: true
      },
      commonConsumptionFields: [
        {
          key: 'cycle_date',
          label: 'Closed Session Date',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'main_consumption',
          label: 'Main Supply (m³)',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'tanker_volume',
          label: 'Tanker Volume (m³)',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'total_supply',
          label: 'Total Supply (m³)',
          sortable: false,
          class: 'text-center'
        },
        {
          key: 'private_consumption',
          label: 'Total Billable Units',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'common_ratio',
          label: 'Common Area Usage',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'tanker_cost',
          label: 'Tanker Cost',
          sortable: true,
          class: 'text-center'
        }
      ],
      form: {
        site_id: null,
        service_type_id: null,
        dateFrom: '',
        dateTo: '',
        page_no: 1,
      },
      listFields: [
        'index',
        {
          key: 'coProp',
          label: 'Site',
          sortable: true,
          'class': 'text-center'
        },
        {
          key: 'meterType',
          label: 'Meter Type',
          sortable: true,
          'class': 'text-center'
        },
        {
          key: 'created_at',
          label: 'Closed Date',
          sortable: true,
          'class': 'text-center'
        },
        {
          key: 'total_lot_count',
          label: 'Total Lots',
          sortable: true,
          'class': 'text-center'
        },
        {
          key: 'total_load_units',
          label: 'Total kWh',
          sortable: true,
          'class': 'text-center'
        },
        {
          key: 'total_load_charge',
          label: 'Load Charge',
          sortable: true,
          'class': 'text-center'
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false,
          'class': 'text-center'
        },
      ],
      baseLotFields: [
        // 'index',
        {
          key: 'id',
          label: 'Ref',
          sortable: true,
          'class': 'text-center'
        },
        {
          key: 'lot.lot_no',
          label: 'Lot No',
          sortable: true,
          'class': 'text-center'
        },
        {
          key: 'lot.lot_owner.name',
          label: 'Owner Name',
          sortable: true,
          'class': 'text-center'
        },
        // {
        //   key: 'previous_unit',
        //   label: 'Previous',
        //   sortable: true,
        //   'class': 'text-center'
        // },
        // {
        //   key: 'current_unit',
        //   label: 'Current',
        //   sortable: true,
        //   'class': 'text-center'
        // },
        {
          key: "units_consumed",
          label: "Units Consumed",
          sortable: true,
          class: "text-center"
        },
        // {
        //   key: 'total_consumption',
        //   label: 'TOTAL CONSUMPTION',
        //   sortable: true,
        //   'class': 'text-center'
        // },
        {
          key: 'net_bill_value',
          label: 'Total Due',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'survey_start_date',
          label: 'Surevey Date',
          sortable: true,
          'class': 'text-center'
        },
        {
          key: 'survey_start_by',
          label: 'Surveyed BY',
          sortable: true,
          'class': 'text-center'
        },
        // {
        //   key: 'survey_end_date',
        //   label: 'Closed Date',
        //   sortable: true,
        //   'class': 'text-center'
        // },
        // {
        //   key: 'surveyor_end_by',
        //   label: 'Closed BY',
        //   sortable: true,
        //   'class': 'text-center'
        // },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false,
          'class': 'text-center'
        },
      ],
      completedSessionList: [],
      lotList: [],
      survoyorDetails: '',
      imgUrl: '',
      imgLoaded: false,
      loupeVisible: false,
      loupeLensStyle: {},
      siteDetails: '',
    }
  },
  computed: {
    ...mapGetters('coprops', ['coPropList', 'meterList']),
    ...mapGetters('sessions', ['completedSessionData', 'completedSessionLots', 'commonConsumptionHistory']),
    sessionSummary() {
      return this.completedSessionLots && this.completedSessionLots.summary && this.completedSessionLots.summary.length
        ? this.completedSessionLots.summary[0]
        : {};
    },
    allDetailRows() {
      return this.completedSessionLots && this.completedSessionLots.data && this.completedSessionLots.data.data
        ? this.completedSessionLots.data.data
        : [];
    },
    mainMeterRow() {
      return this.allDetailRows.find(item => item.is_main === true) || null;
    },
    detailHeaderRow() {
      return this.detailRows[0] || this.mainMeterRow;
    },
    detailRows() {
      return this.allDetailRows.filter(item => item.is_main !== true);
    },
    isWaterDetailSession() {
      return this.siteDetails && this.siteDetails.service_type && this.siteDetails.service_type.id === 1;
    },
    lotFields() {
      return this.baseLotFields;
    },
    allocationBasisLabel() {
      const allocationBasis = this.sessionSummary.allocation_basis || (this.detailRows[0] && this.detailRows[0].allocation_basis);
      if (allocationBasis === 'actual_consumption') {
        return 'Actual consumption';
      }
      if (allocationBasis === 'quote_part') {
        return 'Quote-part / millieme';
      }
      return '-';
    },
    allocationBasisMessage() {
      const allocationBasis = this.sessionSummary.allocation_basis || (this.detailRows[0] && this.detailRows[0].allocation_basis);
      if (allocationBasis === 'actual_consumption') {
        return 'Bowser cost allocated using actual private consumption with estimated historical common-area ratio.';
      }
      if (allocationBasis === 'quote_part') {
        return 'Bowser cost allocated using quote-part / millieme.';
      }
      return 'No bowser allocation applied to this session.';
    }
  },
  methods: {
    ...mapActions('coprops', ['ALL_CO_PROP_LIST', 'ALL_METER_LIST']),
    ...mapActions('sessions', ['COMPLETED_SESSION_LIST', 'COMPLETED_SESSION_LOTS', 'COMMON_CONSUMPTION_HISTORY', 'COMPLETED_SESSION_MAIL', 'COMPLETED_SESSION_MAIL_ANOTHER', 'CRON_ANOTHER']),
    ...mapActions('mailing', ['CHECK_FAILED_MAILINGS']),
    copyUuid(uuid) {
      console.log(uuid, 'uuid');
      // Check if the Clipboard API is available
      if (!navigator.clipboard) {
        this.ERROR_TOAST_MSG('Clipboard API not supported');
        return;
      }
      navigator.clipboard.writeText(uuid)
        .then(() => {
          this.SUCCESS_TOAST_MSG('UUID copied to clipboard!');
        })
        .catch(() => {
          this.ERROR_TOAST_MSG('Failed to copy UUID.');
        });
    },


    downloadImage() {
      const link = document.createElement('a');
      link.href = this.imgUrl;
      link.download = 'meter_image.jpg';
      link.click();
    },
    handleMeterImageLoad() {
      this.imgLoaded = true;
      this.hideLoupe();
    },
    showLoupe() {
      if (!this.imgLoaded) return;
      this.loupeVisible = true;
    },
    hideLoupe() {
      this.loupeVisible = false;
    },
    updateLoupe(event) {
      const image = event.currentTarget.querySelector('img');
      if (!image || !this.imgLoaded) return;

      const rect = image.getBoundingClientRect();
      const offsetX = event.clientX - rect.left;
      const offsetY = event.clientY - rect.top;

      if (offsetX < 0 || offsetY < 0 || offsetX > rect.width || offsetY > rect.height) {
        this.hideLoupe();
        return;
      }

      const lensSize = 180;
      const zoom = 2.5;
      const naturalWidth = image.naturalWidth || rect.width;
      const naturalHeight = image.naturalHeight || rect.height;
      const backgroundX = (offsetX / rect.width) * naturalWidth * zoom;
      const backgroundY = (offsetY / rect.height) * naturalHeight * zoom;

      this.loupeVisible = true;
      this.loupeLensStyle = {
        width: `${lensSize}px`,
        height: `${lensSize}px`,
        left: `${offsetX - lensSize / 2}px`,
        top: `${offsetY - lensSize / 2}px`,
        backgroundImage: `url("${image.currentSrc || image.src}")`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: `${naturalWidth * zoom}px ${naturalHeight * zoom}px`,
        backgroundPosition: `-${backgroundX - lensSize / 2}px -${backgroundY - lensSize / 2}px`
      };
    },
    rowConsumption(item) {
      if (!item) return 0;
      if (item.units_consumed !== undefined && item.units_consumed !== null) {
        return Number(item.units_consumed);
      }
      return Number(item.current_unit || 0) - Number(item.previous_unit || 0);
    },
    totalDue(item) {
      return Number(item.net_bill_value || 0) + Number(item.bowser_amount || 0);
    },
    formatPercent(value) {
      if (value === null || value === undefined || value === '') {
        return '-';
      }
      return `${(Number(value) * 100).toFixed(2)}%`;
    },
    showCommonConsumptionModal() {
      this.$refs.commonConsumptionModal.show();
    },
    ccPageChanged(page) {
      const data = this.siteDetails
      this.COMMON_CONSUMPTION_HISTORY({
        site_id: data.site.id,
        service_type_id: data.service_type.id,
        page
      }).catch(() => { });
    },
    getCoPropList() {
      // Get all site list
      return this.ALL_CO_PROP_LIST().then(() => {
      }).catch((e) => {
      });
    },
    getMeterList() {
      if (!this.form.site_id) {
        return Promise.resolve();
      }
      let meterListDetails = {
        site_id: this.form.site_id
      }
      return this.ALL_METER_LIST(meterListDetails).then(() => {
      }).catch((e) => {
        console.log(e);
      })
    },
    modifyPage(data) {
      data.page_no = 1
      this.form.page_no = 1
      this.getCompletedList(data)
    },
    getCompletedList(data) {
      if (data.dateTo == '' && data.dateFrom !== '') {
        data.dateTo = moment().format('YYYY-MM-DD').toString()
      }
      if (data.dateTo != '') {
        if (moment(data.dateTo).format('YYYYMMDD') < moment(data.dateFrom).format('YYYYMMDD')) {
          this.ERROR_TOAST_MSG('Please select to date greater than from date');
        } else {
          data.dateFrom = moment(data.dateFrom).format('YYYY-MM-DD').toString()
          data.dateTo = moment(data.dateTo).format('YYYY-MM-DD').toString()
        }
      }

      // console.log(data, '*****************')
      return this.COMPLETED_SESSION_LIST(data).then(() => {
        // console.log(this.completedSessionData, "===completedSessionData")
        this.completedSessionList = this.completedSessionData.data.data
      }).catch(() => {

      });
    },
    async applyRoutePrefill() {
      const routePayload = this.$route.query.view || this.$route.query.prefill
      if (!routePayload) {
        return
      }

      try {
        const session = JSON.parse(atob(routePayload))
        this.form.site_id = session.site_id
        await this.getMeterList()
        this.form.service_type_id = session.service_type_id
        await this.getCompletedList(this.form)

        if (this.$route.query.view) {
          const site = this.coPropList.data && this.coPropList.data.find(s => s.id == session.site_id)
          const serviceType = this.meterList && this.meterList.find(m => m.id == session.service_type_id)
          const data = {
            site: site || { id: session.site_id, name: '' },
            service_type: serviceType || { id: session.service_type_id, service_name: '' },
            uuid: session.uuid,
            created_at: session.created_at
          }
          this.$nextTick(() => this.detailView(data, 'view'))
        }
      } catch (e) { }
    },
    listView() {
      this.siteDetails = ''
      this.listFlag = true
      this.viewFlag = false
      this.$refs.commonConsumptionModal.hide()
    },
    showDownloadModal(id) {
      this.$refs['download-modal-' + id].show()
    },
    showEmailModal(id) {
      this.$refs['email-modal-' + id].show()
    },
    hideDownloadModal() {
      this.$refs['download-modal'].hide()
    },
    toggleDownloadModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['download-modal'].toggle('#toggle-btn')
    },
    pageClick(pageNo) {
      this.form.page_no = pageNo
      this.getCompletedList(this.form)
    },
    detailPageClick(pageNo) {
      this.detailView(this.detailData, 'view', pageNo)
    },
    detailView(data, flag, pageNo = 1) {
      this.detailData = data
      if (flag == 'view') {
        this.siteDetails = data
        this.listFlag = false
        this.viewFlag = true

        let payload = {
          site_id: data.site.id,
          uuid: data.uuid,
          service_type_id: data.service_type.id,
          created_at: moment(data.created_at).format('YYYY-MM-DD'),
          page_no: pageNo
        }
        this.COMPLETED_SESSION_LOTS(payload).then(() => {
          this.pagination = this.completedSessionLots.data;
          if (data.service_type.id === 1) {
            this.ccPage = 1
            this.COMMON_CONSUMPTION_HISTORY({
              site_id: data.site.id,
              service_type_id: data.service_type.id,
              page: 1
            }).catch(() => { });
          }
        }).catch(() => { });
      }


      else if (flag === 'lotImage') {
        this.$refs.imgModal.show();
        this.imgUrl = noImageUrl;
        this.loadingImage = true;
        this.imgLoaded = false;
        this.hideLoupe();

        const path = data.item.meter_image_path || data.item.meter_image;
        this.currentLotNo = data.item.lot.lot_no || '';
        if (path) {
          const encodedPath = btoa(path);
          fetch(`${this.apiUrl}signed-url/${encodedPath}`, {
            headers: {
              Authorization: `Bearer ${localStorage.token}`,
            },
          })
            .then((res) => res.json())
            .then((res) => {
              if (res.status && res.url) {
                this.imgUrl = res.url;
              } else {
                this.imgUrl = noImageUrl;
              }
            })
            .catch(() => {
              this.imgUrl = noImageUrl;
            })
            .finally(() => {
              this.loadingImage = false;
            });
        } else {
          this.loadingImage = false;
        }
      }
      // else if (flag == 'lotImage') {
      //   this.$refs.imgModal.show()
      //   this.imgUrl = (data.item.meter_image) ? `${data.item.meter_image}` : noImageUrl
      // } 

      else if (flag == 'mail' || flag == 'another') {
        this.pendingMailPayload = {
          site_id: data.site.id,
          uuid: data.uuid,
          service_type_id: data.service_type.id,
          created_at: moment(data.created_at).format('YYYY-MM-DD'),
          type: flag == 'mail' ? 'bill' : 'notify'
        }
        this.pendingMailFlag = flag
        this.mailCheckFailures = []
        this.mailCheckLoading = true
        this.$refs.mailCheckModal.show()
        this.CHECK_FAILED_MAILINGS({ site_id: data.site.id })
          .then(response => {
            this.mailCheckLoading = false
            this.mailCheckFailures = response.data || []
            if (this.mailCheckFailures.length === 0) {
              setTimeout(() => {
                this.$refs.mailCheckModal.hide()
                this.proceedWithMailing()
              }, 1200)
            }
          })
          .catch(() => {
            this.mailCheckLoading = false
            this.$refs.mailCheckModal.hide()
            this.proceedWithMailing()
          })
      } else if (flag == "cronAnother") {
        this.CRON_ANOTHER().then(() => {
          this.getCompletedList(this.form)
        })
      }
    },

    proceedWithMailing() {
      this.$refs.mailCheckModal.hide()
      this.COMPLETED_SESSION_MAIL(this.pendingMailPayload).then(() => {
        this.getCompletedList(this.form)
        this.pendingMailPayload = null
        this.pendingMailFlag = null
      })
    },
  },
  created() {
    document.body.classList.remove('modal-open');

    if (!localStorage.token) {
      localStorage.clear()
      next({
        name: 'adminLogin'
      })
    } else {
      if (localStorage.roleId == 1) {
        this.$router.replace({ name: "dashboard" });
      }

      this.getCoPropList().then(() => this.applyRoutePrefill());
    }
  },
  beforeDestroy() {
    document.body.classList.remove('modal-open');
  }
}
</script>
<style scoped>
.font-size a {
  width: 25px;
}

.session-summary-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  border-radius: 10px;
  background: #f8fafd;
  border: 1px solid #dbeafe;
}

.stat-chip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px 20px;
  border-right: 1px solid #e2eaf5;
  min-width: 140px;
}

.stat-chip:last-child {
  border-right: none;
}

.stat-chip--action {
  justify-content: center;
  min-width: 160px;
}

.stat-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #94a3b8;
  margin-bottom: 3px;
  white-space: nowrap;
}

.stat-value {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.3;
}

.stat-note {
  font-size: 11px;
  color: #94a3b8;
  margin-top: 2px;
  line-height: 1.3;
}

.loupe-wrapper {
  position: relative;
  display: inline-block;
  cursor: zoom-in;
  overflow: hidden;
}

.image-viewer-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
}

.loader-center {
  margin: 0 auto;
}

.fullscreen-modal {
  max-width: 100vw !important;
  height: 100vh !important;
  margin: 0 !important;
}

.fullscreen-modal .modal-content {
  height: 100vh;
}

.fullscreen-modal .modal-body {
  padding: 0;
  display: flex;
}

.fullscreen-image-wrapper {
  max-width: 100%;
  max-height: 100%;
}

.fullscreen-image {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.download-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1000;
}

.loupe-lens {
  position: absolute;
  border: 2px solid rgba(255, 255, 255, 0.95);
  border-radius: 50%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  pointer-events: none;
}

::v-deep .supply-history-modal .modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex: 1;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/Admin/completedSession.vue